import React from 'react';
import PropTypes from 'prop-types';

// Mixins
import isResizable from '../../mixins/resizable';

const SIDEBAR_COLLAPSED_KEY = 'v6-sidebar-collapsed';

export class SidebarNav extends React.Component {
  static propTypes = {
    content: PropTypes.node.isRequired,
    isDesktop: PropTypes.bool,
  }

  static defaultProps = {
    isDesktop: false,
  }

  constructor(props) {
    super(props);

    this.state = {
      collapsed: false,
    };
  }

  componentDidMount() {
    let collapsed = false;

    try {
      collapsed = window.localStorage.getItem(SIDEBAR_COLLAPSED_KEY) === 'true';
    } catch (_error) {
      collapsed = false;
    }

    this.setState({ collapsed });
    this.updateDocumentState(collapsed);
  }

  componentWillUnmount() {
    document.documentElement.removeAttribute('data-sidebar-collapsed');
  }

  updateDocumentState = (collapsed) => {
    document.documentElement.setAttribute(
      'data-sidebar-collapsed',
      collapsed ? 'true' : 'false'
    );
  }

  toggleCollapsed = () => {
    this.setState(
      ({ collapsed }) => ({
        collapsed: !collapsed,
      }),
      () => {
        const { collapsed } = this.state;

        try {
          window.localStorage.setItem(
            SIDEBAR_COLLAPSED_KEY,
            collapsed ? 'true' : 'false'
          );
        } catch (_error) {
          // localStorage may be unavailable. The sidebar can still collapse
          // for the current page.
        }

        this.updateDocumentState(collapsed);
      }
    );
  }

  render() {
    const { isDesktop, content } = this.props;
    const { collapsed } = this.state;

    if (!isDesktop) {
      return null;
    }

    const renderedContent = React.isValidElement(content)
      ? React.cloneElement(content, {
        collapsed,
        onToggleCollapsed: this.toggleCollapsed,
      })
      : content;

    return (
      <div className='nav-content'>
        {renderedContent}
      </div>
    )
  }
}

export default isResizable(SidebarNav);
